import * as React from 'react';
import { useState } from "react";
import Button from "@material-ui/core/Button/Button";
import Typography from "@material-ui/core/Typography/Typography";
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import OnboardPortfolios from "./components/OnboardPortfolios";
import OnboardStrategyChange from "./components/OnboardStrategyChange";
import {withStyles} from "@material-ui/core";

import {
  Transition,
} from '../';

const styles = {
  paper: {
    width: '100%',
  },
  modalCloseBtn: {
    position: 'absolute',
    top: 20,
    right: 20
  }
};

const OnboardPortfoliosDialog = ({isOpen, isMultiple, onCancel, classes, selectedPortfolios, callbacks, household, history}) => {
  const [isMultipleVisisble, setIsMultipleVisisble] = useState(!!isMultiple);
  const [closeBtnVisisble, setCloseBtnVisible] = useState(true);
  const hideCloseBtn = () => setCloseBtnVisible(false);

  const isStrategyChange = selectedPortfolios.length === 1 && !!selectedPortfolios[0].predecessorPortfolioId;

  return (
    <Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      onClose={onCancel}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      maxWidth={'lg'}
      scroll={'paper'}
      classes={{paper: classes.paper}}
    >
      {
        isStrategyChange ?
          <DialogTitle id="alert-dialog-slide-title">Onboard Portfolio Changes </DialogTitle>
          :
          <DialogTitle id="alert-dialog-slide-title"> Onboard Portfolio{isMultiple && "s"}</DialogTitle>
      }
      {
        closeBtnVisisble &&
        <IconButton className={classes.modalCloseBtn} aria-label="Close" onClick={onCancel}><CloseIcon color="primary"/></IconButton>
      }
      <DialogContent>
        {isMultipleVisisble ? (
          <Typography variant={"body1"}>
            All accounts selected for multiple-onboarding must be completed
            before the application is submitted for signatures. If you do not
            have complete information for an account, please onboard it
            separately.
          </Typography>
        ) : (
          isStrategyChange ? (
            <OnboardStrategyChange
              household={household}
              onClose={onCancel}
              selectedPortfolio={selectedPortfolios[0]}
              callbacks={callbacks}
              history={history}
              hideCloseBtn={hideCloseBtn}
            />
          ) : (
            <OnboardPortfolios
              household={household}
              onClose={onCancel}
              selectedPortfolios={selectedPortfolios}
              callbacks={callbacks}
              history={history}
              hideCloseBtn={hideCloseBtn}
            />
          )
        )}
      </DialogContent>
      {isMultipleVisisble && (
        <DialogActions>
          <Button variant="contained" color="primary" onClick={() => setIsMultipleVisisble(false)}>Continue</Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default withStyles(styles)(OnboardPortfoliosDialog);




// WEBPACK FOOTER //
// ./src/components/OnboardPortfoliosDialog/index.jsx